module.exports = __webpack_public_path__ + "static/media/azubu-logo.07b6399a.mp4";